<template>
  <div>
    <loader object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#4F46E5" objectbg="#999793" opacity="80" name="circular" v-if="overlayActive"></loader>
      <div id="app" data-bs-spy="scroll" data-bs-target="#navbarScroll" data-bs-offset="0">
        <router-view />
      </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      overlayActive: false,
    }
  },
  mounted(){
   this.switchOverlay()
  },
  methods: {
    switchOverlay(){
      this.overlayActive = true;
      document.getElementById("app").style.opacity = 0;
      setTimeout(()=>{
        document.getElementById("app").style.opacity = 1;
        this.overlayActive = false;
      },3000)
    }
  }
}
</script>
<style>
:root {
  --dacode-primary-color: #4F46E5;
  --dacode-secondary-color: #ff9900;
  --dacode-white-color: #FFFFFF;
  --dacode-dark-color: #000000;
}

html,body {
  overflow-x: hidden !important;
}

body {
  font-family: 'Poppins', sans-serif;
  line-height: 1.5;
  text-rendering: optimizeLegibility;
  margin-top: 4.2rem;
  background-color: var(--bs-light);
  scroll-behavior: smooth;
}

a {
  text-decoration: none;
}

@media (max-width: 991.98px){
  .header-text h1 {
    font-size: 2.5rem !important;
  }

  #about p {
    font-size: 1rem;
  }

  .header-left {
    text-align: center;
  }

}

@media (max-width: 767.98px){
  .call-to-action , .call-to-action-outline {
    padding: .6rem 1.2rem !important;
  }

  .training-button, #contact .call-to-action {
    padding: .8rem 1.8rem !important;
  }
  
  .navbar-brand img {
    height: 35px !important;
    width: 140px !important;
  }
  
  .header-image {
    text-align: center;
  }

}

@media (min-width: 768px) and (max-width: 991.98px){
  .header-left {
    text-align: center;
  }

  .header-image {
    text-align: center;
  }

  .header-image img {
    height: 300px !important;
  }
}
</style>